<template>
	<div class="salary" ref="salary">
		<div class="salary__head">

			<div class="salary__item">
				<div class="z-select">
					<div class="z-select__label">Academy</div>
					<multiselect
							v-model="academy"
							placeholder="Select academy"
							label="name"
							track-by="id"
							:options="academies"
							:multiple="false"
							open-direction="bottom"
							@input="getShedule()"
					>
					</multiselect>
				</div>
			</div>

			<div v-if="academy" class="salary__item">
				<div class="z-select">
					<div class="z-select__label">Specify the week</div>
					<datetime
							v-model="week"
							:config="datetimePickerConfig"
							class="flatpickr"
							placeholder="Select data"
					>
					</datetime>
				</div>
			</div>

			<div class="spiner_gradebook" v-if="submiting"
			     style="width:100%; display:flex; justify-content: center; align-items: center;">
				<img src="/img/spiner.gif" alt="spiner" width="150" height="auto" style="object-fit: contain">
			</div>
		</div>
		<div class="salary__body">
			<div class="z-table-wrap2" v-if="periods">

				<table>
					<tr>
						<td></td>
						<td v-for="day in periods.days">{{ day.week_day_name }}</td>
					</tr>
					<tr>
						<td></td>
						<td v-for="day in periods.days">{{ day.date }}</td>
					</tr>
					<tr v-for="(time, index) in periods.table">
						<td>{{ index }}</td>
						<template v-for="(item, date) in time">
							<td :style="{ 'background-color': item.color }" @click="chosePeriod(date, index, item )">
								{{ item.value }}
							</td>
						</template>

					</tr>
				</table>
			</div>
		</div>

		<div class="z-modal" v-if="student_modal" :class="{ is_active: student_modal }">
			<div class="z-modal__overlay" @click.self="student_modal = null">
				<div class="z-modal__window">
					<div class="z-modal__header">
						<div class="z-modal__heading">
							<template v-if="student_modal.status === 2">
								Урок відпрацьовано
							</template>
							<template v-if="student_modal.status === 3">
								Відпрацювання уроку
							</template>
						</div>
						<button type="button" class="z-modal__close" @click="student_modal = null"></button>
					</div>
					<div class="z-modal__main">

						<div class="z-practice">

							<div class="z-practice__item">
								<div class="z-select">
									<div class="z-select__label">Учень</div>
									<input disabled type="text" class="form-control"
									       :value="student_modal.period.student.full_name">
								</div>
							</div>

							<div class="z-practice__item">
								<div class="z-select">
									<div class="z-select__label">Група</div>
									<input disabled type="text" class="form-control"
									       :value="student_modal.period.group.name">
								</div>
							</div>

							<div class="z-practice__item" v-if="student_modal.period.program">
								<div class="z-select">
									<div class="z-select__label">Програма</div>
									<input disabled type="text" class="form-control"
									       :value="student_modal.period.program.name">
								</div>
							</div>
                            <div class="z-practice__item" v-if="student_modal.period.type">
                                <div class="z-select">
                                    <div class="z-select__label">Формат</div>
                                    <input disabled type="text" class="form-control"
                                           :value="student_modal.period.type">
                                </div>
                            </div>
                            <div class="z-practice__item" v-if="student_modal.period.type === 'online'">
                                <div class="z-select">
                                    <div class="z-select__label">Посилання на відпрацювання</div>
                                    <input  type="text" class="form-control"
                                           v-model="student_modal.period.link">
                                </div>
                            </div>
							<div class="z-practice__item" v-if="student_modal.period.lesson">
								<div class="z-select">
									<div class="z-select__label">Lesson</div>
									<input disabled type="text" class="form-control"
									       :value="(student_modal.period.date) ? (student_modal.period.lesson.name + ' (дата проведення: ' + student_modal.period.date+')') : student_modal.period.lesson.name">
								</div>
							</div>
                            <div class="z-practice__item" v-if="student_modal.period.comment">
                                <div class="z-select">
                                    <div class="z-select__label">Comment</div>
                                    <textarea disabled type="text" class="form-control">{{student_modal.period.comment}}</textarea>
                                </div>
                            </div>
                            <div class="z-practice__item" v-if="student_modal.period.phone">
                                <div class="z-select">
                                    <div class="z-select__label">Телефон</div>
                                    <textarea disabled type="text" class="form-control">{{ student_modal.period.phone }}</textarea>
                                </div>
                            </div>

						</div>
					</div>
					<div class="z-modal__footer">
						<div class="z-modal__btns z-modal__btns_sb" v-if="student_modal.status === 3">
							<button class="btn btn-primary btn-spinner pull-right m-b-0"
							        @click="student_modal = null"
							        type="button">
								<i class="fa"></i>
                                Close
							</button>
                            <button class="btn btn-danger btn-spinner pull-right m-b-0" @click="confirmDeletePeriod"
                                    :disabled="submiting" type="button">
                                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                                Відмiнити бронь
                            </button>
                            <button class="btn btn-info btn-spinner pull-right m-b-0" @click="updatePractice"
                                    :disabled="submiting" type="button">
                                <i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
                                Зберегти змiни
                            </button>
							<button class="btn btn-primary btn-spinner pull-right m-b-0" @click="doneLesson"
							        :disabled="submiting" type="button">
								<i class="fa" :class="submiting ? 'fa-spinner' : ''"></i>
								Відпрацьовано
							</button>
						</div>

						<div class="z-modal__btns z-modal__btns_sb" v-else>
							<button class="btn btn-primary btn-spinner pull-right m-b-0"
							        @click="student_modal = null"
							        type="button">
								<i class="fa"></i>
								Добре
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<notifications position="bottom right"/>
	</div>
</template>

<style>
.choose {
	background-color: var(--c2) !important;
}

.error {
	color: red;
	border: 1px solid red;
	width: 40%;
	padding: 2px 2px 2px 26px;
	border-radius: 6px;
	background-color: antiquewhite;
}

td {
	cursor: pointer;
}

.student_modal {
	position: absolute;
	top: 20%;
	background-color: antiquewhite;
	padding: 10px;
	width: 664px;
	height: 401px;
	border: solid 1px black;
	border-radius: 13px;
}
</style>

<script>

import axios from "axios";


export default {
	name: "TutorPractice",
	props: ['tutor_data', 'week_data', 'academies_data'],
	data() {
		return {
			submiting: false,
			showError: false,
			periods: null,
			tutor: null,
			student_modal: null,
			academy: null,
			academies: [],
			week: null,
			datetimePickerConfig: {
				enableMonth: true,
				altFormat: "Y-m-d",
				dateFormat: "Y-m-d",
				locale: {firstDayOfWeek: 1},
				disable: [
					function (date) {
						return ([0, 2, 3, 4, 5, 6].includes(date.getDay()));
					}
				],
				onClose: (selectedDates, dateStr, instance) => {
					this.getShedule(instance);
				},
			},
		}
	},
	mounted() {
		this.tutor = this.tutor_data;
		this.week = this.week_data;
		this.academies = this.academies_data;
	},
	methods: {
		chosePeriod(day, time, item) {
			this.student_modal = null;
			this.errors.clear();
			if (item.status !== 0 && item.status !== 1) {
				if (time === "20:00") {
					this.student_modal === "19:40";
				}
				this.student_modal = item;
				this.student_modal.start = time;
				this.student_modal.end = this.getEndPeriod(time);
			}
		},
        async updatePractice(){
            try {
                await axios.post('practice/updatePractice', this.student_modal.period);
                this.$notify({type: 'success', title: 'Успішно', text: 'Змiни успiшно застосовані', duration: 5000});
                this.student_modal = null;
                this.getShedule();
            } catch (error) {
                this.errors.clear()
                let errors = error.response.data.errors;
                for (var prop in errors) {
                    this.errors.add({field: prop, msg: errors[prop][0]});
                }
            }
        },
		getEndPeriod(start) {
			var myarr = start.split(":");
			var end;
			var hour = parseInt(myarr[0]);
			if (myarr[1] === "20") {
				end = [hour, "40"].join(':')
			} else if (myarr[1] === "00") {
				end = [hour, "20"].join(':')
			} else {
				end = [hour + 1, "00"].join(':')
			}
			return end;
		},
		forceUpdate() {
			this.$forceUpdate();
		},
		async getShedule(instance = null) {

			var week = (instance) ? instance.formatDate(instance.latestSelectedDateObj, "Y-m-d") : this.week;
			this.submiting = true;
			let post_data = {
				week: week,
				academy_id: this.academy.id,
				tutor_id: this.tutor.id
			};

			try {
				const {data: {periods}} = await axios.post('practice/getShedule', post_data);
				this.periods = periods;
			} catch (error) {
				this.errors.clear();
				let errors = error.response.data.errors;
				for (var prop in errors) {
					this.errors.add({field: prop, msg: errors[prop][0]});
				}
			}
			this.submiting = false;
		},

		async doneLesson() {
			try {
				await axios.post('practice/doneLesson', this.student_modal.period);
				this.$notify({type: 'success', title: 'Успішно', text: 'Урок успішно відзначений як відпрацьований', duration: 5000});
				this.student_modal = null;
				this.getShedule();
			} catch (error) {
				this.errors.clear()
				let errors = error.response.data.errors;
				for (var prop in errors) {
					this.errors.add({field: prop, msg: errors[prop][0]});
				}
			}
		},

        async confirmDeletePeriod(){
            try {
                await axios.post('practice/confirmDeletePeriod', this.student_modal.period);
                this.$notify({type: 'warning', title: 'Success!', text: 'Бронь урока була вiдмiнина', duration: 4000});
                this.student_modal = null;
                this.getShedule();
            } catch (error) {
                this.errors.clear();
                let errors = error.response.data.errors;
                for (var prop in errors) {
                    this.errors.add({field: prop, msg: errors[prop][0]});
                }
            }
        }

	}
}
</script>
<style lang="sass" scoped>
@function gridItem($num, $name)
	$val: ''
	@for $i from 1 through $num
		$val: '#{$val}#{$name}#{$i} '
	@return $val

=gridItem($num, $name)
	> *
		@for $i from 1 through $num
			&:nth-child(#{$i})
				grid-area: #{$name}#{$i}

.z-error-item
	color: #cf142b
	background-color: rgba(#CF142B, .2)
	padding: 10px
	font-size: 12px
	line-height: 1.1

.z-select
	input
		min-height: 46px
		color: #35495e
		font-size: 14px
		border: 1px solid #e8e8e8
		border-radius: 5px
		box-shadow: none

.salary
	display: grid
	grid-template-columns: 100%
	grid-gap: 20px
	&__head
		display: grid
		grid-gap: 10px 20px
		grid-template-columns: 100%
		@media (min-width: 1280px)
			grid-template-columns: repeat(4, 1fr)
			grid-template-areas: 'salary-itm-1 salary-itm-1 salary-itm-2 salary-itm-2' 'salary-itm-3 salary-itm-3 salary-itm-3 salary-itm-3' 'salary-itm-4 . . .'
			+gridItem(4, 'salary-itm-')
	&__item
		&.is_shedule
			display: grid
			grid-template-columns: 100%
			@media (min-width: 545px)
				grid-template-columns: 3fr 1fr
				align-items: flex-end
			button
				min-height: 46px
				border-radius: 0
				margin-top: -1px
				@media (min-width: 545px)
					margin-top: 0
					margin-left: -1px
					width: calc(100% + 1px)
		&.is_btns
			button
				margin-top: 10px
				width: 100%
				min-height: 46px
				border-radius: 0
	&__body
		.z-table-wrap2
			margin-top: 0
		table
			tr
				&:nth-child(odd)
					td
						background-color: #dddddd
			td
				text-align: center

</style>
<style lang="sass">
.z-table-wrap2
	max-width: 100%
	overflow-y: hidden
	overflow-x: auto
	position: relative
	border-right: 1px solid #ddd
	border-bottom: 1px solid #ddd
	border-left: 1px solid #ddd
	padding-bottom: 0

	table
		width: calc(100% + 1px)
		margin: 0 -1px -1px
		border: none !important
	tr
		top: unset !important
		position: unset !important
		border: none !important
		&:nth-child(odd)
			td
				background-color: #ddd
	td
		box-shadow: inset 1px 0 0 0 #ddd, inset 0 -1px 0 0 #ddd
		border: none !important
		padding: 5px 8px

	&.is_periods td
		text-align: center
.z-practice
	display: grid
	grid-gap: 10px
	& + &
		margin-top: 20px
		padding-top: 14px
		position: relative
		&::before
			content: ''
			width: calc(100% + (var(--z-modal_window_offset-x) * 2))
			height: 1px
			background-color: #ddd
			position: absolute
			left: calc(var(--z-modal_window_offset-x) * -1)
			top: 0
	&__item
		&-error
			color: #CF142B
			font-size: 11px
			margin-top: 2px
.salary
	.flatpickr-calendar
		position: fixed !important
		top: 50% !important
		left: 50% !important
		transform: translate(-50%, -50%) !important
		animation: none !important
		&::before
			width: 100vw !important
			height: 100vh !important
			background-color: rgba(#000, .4) !important
			position: fixed !important
			top: 50% !important
			left: 50% !important
			transform: translate(-50%, -50%) !important
			z-index: -1 !important
			pointer-events: auto !important
		&::after
			display: none !important
		> *
			background-color: #fff

.hover-cursor
	cursor: pointer
	&:active
		background-color: rgba(#ddd, .4)
		transform: scale(0.96, 0.8)
</style>
